import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute: React.FC<{ children: React.ReactNode; allowAnonymous?: boolean }> = ({
  children,
  allowAnonymous = false,
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--color-bg-primary)',
        }}
      >
        <div className='spinner' />
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  // If user is anonymous BUT route doesn't allow it, redirect to signup
  if (user.isAnonymous && !allowAnonymous) {
    return <Navigate to='/signup' state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
